import { render, staticRenderFns } from "./contract-verification-result.component.vue?vue&type=template&id=31297786"
import script from "./contract-verification-result.component.vue?vue&type=script&lang=ts"
export * from "./contract-verification-result.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports